document.addEventListener('DOMContentLoaded', () => {
    // Define the hardcoded subscription text
    const subscriptionText = "Subscribe & save 10%";
    const originalPrice = "£23.50"; // Price for one-time purchase
    const discountedPrice = "£21.15"; // Price for subscription

    // Get the Buy button using the 'push-btn' class
    const buyButton = document.querySelector('.push-btn');
    
    if (buyButton) {

      
        // Check for the subscription radio button using a different selector or XPath
        const subscribeRadioButton = document.querySelector('input[value="subscription"]'); // Update this with correct selector
        console.log('Subscribe radio button:', subscribeRadioButton); // Log subscription button

        // Check for the buy one-time radio button using a different selector or XPath
        const buyOneTimeRadioButton = document.querySelector('input[value="onetime"]'); // Update this with correct selector
        console.log('Buy one-time radio button:', buyOneTimeRadioButton); // Log one-time button

        // Listen for changes in the radio button selection
        // if (subscribeRadioButton) {
        //     subscribeRadioButton.addEventListener('change', () => {
        //         // When "Subscribe & Save 10%" option is selected, update the Buy button
        //         updateBuyButton(discountedPrice, subscriptionText);
        //     });
        // }

        // if (buyOneTimeRadioButton) {
        //     buyOneTimeRadioButton.addEventListener('change', () => {
        //         // When "Buy one-time" option is selected, update the Buy button with the original price
        //         updateBuyButton(originalPrice, "Buy one-time");
        //     });
        // }

        // // Check if the button is already selected on page load and set correct price
        // if (subscribeRadioButton.checked) {
        //     updateBuyButton(discountedPrice, subscriptionText);
        // } else if (buyOneTimeRadioButton.checked) {
        //     updateBuyButton(originalPrice, "Buy one-time");
        // }
    }
 //updateBuyButton(5, "Buy one-time");
    // Function to update the Buy button text and price
    function updateBuyButton(price, text) {
      console.log('in');
        if (!buyButton) return;
  
        const buttonTextSpan = buyButton.querySelector('span'); // Assuming the button contains a span for text
        const priceSpan = buyButton.querySelector('span[x-html="formatMoney(currentPrice)"]'); // Assuming there's another span for price

        if (buttonTextSpan) {
          console.log('inn');
            buttonTextSpan.innerText = `Buy Now - ${text}`; // Update with subscription text or Buy one-time text
        }

        if (priceSpan) {
          console.log('innn');
            priceSpan.innerHTML = price; // Update with price
        }

        console.log('Updated Buy Button Text:', buyButton.innerText); // Debug updated button text
    }

  document.addEventListener('change', function (event) {
  const target = event.target;
 console.log('Radio option selected:');
  if (
    target.matches('input[type="radio"][name="purchaseOption"]')
  ) {
    console.log('Radio option selected:', target.value);

    // Optional: log if it's "onetime"
    if (target.value === 'onetime') {
      console.log('User selected the one-time purchase option.');
    }
  }
});
});



